module.exports = __webpack_public_path__ + "static/media/organisations.953f9f4a.svg";